export interface ProjectRequestCountStoreType {
  projectRequestCount: number;
}

export enum ProjectRequestCountStoreKind {
  INITIAL = 'INITIAL',
}

export interface ProjectRequestCountStoreAction {
  type: ProjectRequestCountStoreKind;
}
